// Website-specific configuration for multi-tenant platform
// Each client has their own branding, contact info, and promotional content

const websiteConfigs = {
  'nc-exams': {
    name: 'NC Exams',
    fullName: 'Nava Chaitanya Competitions',
    logo: '/adaptive-icon.png', // Default NC Exams logo
    contactName: 'Rajesh Sir',
    phones: ['9030436395'],
    email: 'contact@navachaitanya.net',
    adminWhatsApp: '9030436395', // Admin WhatsApp number for notifications
    paymentQR: '/qr/nc-exams-payment-qr.png', // Payment QR code image
    paymentContactNumber: '9030436395', // Contact number for payment screenshot
    promotionalBanner: '/promotions/english-with-rajesh-1.jpeg',
    description: 'మా Exams, మా మాట ప్రకారం ఉన్నాయో తెలుసుకోవడానికి - మీకు కావాల్సిన Exams Package పైన క్లిక్ చేసి - **Free SAMPLE Exams** లో ఉండే Chapter 1 Exams ని రాయగలరు.... మరిన్ని వివరాలకు {contactName} కి Call చేయగలరు **{phone}**',
    admins: [9640717460, 7396019228, 9030436395], // Admin phone numbers
    theme: {
      primaryColor: '#38bdf8',
      accentColor: 'rgba(56, 189, 248, 0.3)',
    },
    is_special_website: false,
  },
  'exams-with-rajesh': {
    name: 'Exams with Rajesh',
    fullName: 'Excel in Your Exams',
    logo: '/adaptive-icon-BmWJF519.png',
    contactName: 'Rajesh Sir',
    phones: ['9030436395'],
    email: 'contact@navachaitanya.net',
    adminWhatsApp: '9030436395', // Admin WhatsApp number for notifications
    paymentQR: '/qr/exams-with-rajesh-payment-qr.jpeg', // Payment QR code image
    paymentContactNumber: '9030436395', // Contact number for payment screenshot
    promotionalBanner: '/promotions/english-with-rajesh-1.jpeg',
    description: 'మా Exams, మా మాట ప్రకారం ఉన్నాయో తెలుసుకోవడానికి - మీకు కావాల్సిన Exams Package పైన క్లిక్ చేసి - **Free SAMPLE Exams** లో ఉండే Chapter 1 Exams ని రాయగలరు.... మరిన్ని వివరాలకు {contactName} కి Call చేయగలరు **{phone}**',
    admins: [9640717460, 7396019228, 9030436395], // Admin phone numbers
    theme: {
      primaryColor: '#38bdf8',
      accentColor: 'rgba(56, 189, 248, 0.3)',
    },
    is_special_website: false,
  },
  'sri-lakshya': {
    name: 'SRI LAKSHYA',
    fullName: 'Sri Lakshya Publications',
    logo: '/srilakhya.jpeg', // Sri Lakshya logo
    contactName: 'Lakshya Support',
    phones: ['9502439204', '9550039204'],
    email: 'lakshyapublications123@gmail.com',
    adminWhatsApp: '9502439204', // Admin WhatsApp number for notifications
    paymentQR: '/qr/sri-lakshya-payment-qr.jpeg', // Payment QR code image
    paymentContactNumber: '9502439204', // Contact number for payment screenshot
    promotionalBanner: null, // No promotional banner yet
    description: 'మా Exams, మా మాట ప్రకారం ఉన్నాయో తెలుసుకోవడానికి - మీకు కావాల్సిన Exams Package పైన క్లిక్ చేసి - **Free SAMPLE Exams** లో ఉండే Chapter 1 Exams ని రాయగలరు.... మరిన్ని వివరాలకు {contactName} కి Call చేయగలరు **{phones}**',
    admins: [9640717460, 7396019228, 9030436395, 9502439204], // Admin phone numbers (including Sri Lakshya admin)
    theme: {
      primaryColor: '#38bdf8',
      accentColor: 'rgba(56, 189, 248, 0.3)',
    },
    is_special_website: false,
  },
  '360exams': {
    name: '360Exams',
    fullName: '360Exams',
    logo: '/schools360.jpeg',
    contactName: 'Support',
    phones: ['9949866498'],
    email: 'support@schools360.in',
    adminWhatsApp: '9951866498',
    paymentQR: '/qr/default-payment-qr.png',
    paymentContactNumber: '9951866498',
    promotionalBanner: null,
    description: 'మా Exams, మా మాట ప్రకారం ఉన్నాయో తెలుసుకోవడానికి - మీకు కావాల్సిన Exams Package పైన క్లిక్ చేసి - **Free SAMPLE Exams** లో ఉండే Chapter 1 Exams ని రాయగలరు.... మరిన్ని వివరాలకు {contactName} కి Call చేయగలరు **{phones}**',
    admins: [9640717460, 7396019228, 9030436395, 9949866498, 9951866498],
    theme: {
      primaryColor: '#38bdf8',
      accentColor: 'rgba(56, 189, 248, 0.3)',
    },
    is_special_website: true,
  },
  // Default fallback configuration
  'default': {
    name: '360Exams',
    fullName: '360Exams',
    logo: '/schools360.jpeg',
    contactName: 'Support',
    phones: ['9949866498'],
    email: 'support@schools360.in',
    adminWhatsApp: '9951866498', // Admin WhatsApp number for notifications
    paymentQR: '/qr/default-payment-qr.png', // Payment QR code image
    paymentContactNumber: '9951866498', // Contact number for payment screenshot
    promotionalBanner: null,
    description: 'మా Exams, మా మాట ప్రకారం ఉన్నాయో తెలుసుకోవడానికి - మీకు కావాల్సిన Exams Package పైన క్లిక్ చేసి - **Free SAMPLE Exams** లో ఉండే Chapter 1 Exams ని రాయగలరు.... మరిన్ని వివరాలకు {contactName} కి Call చేయగలరు **{phones}**',
    admins: [9640717460, 7396019228, 9030436395, 9949866498, 9951866498],
    theme: {
      primaryColor: '#38bdf8',
      accentColor: 'rgba(56, 189, 248, 0.3)',
    },
    is_special_website: false,
  }
};

/**
 * Get configuration for a specific website
 * @param {string} websiteId - The website identifier (e.g., 'nc-exams', 'sri-lakshya')
 * @returns {object} Website configuration object
 */
export const getWebsiteConfig = (websiteId) => {
  const config = websiteConfigs[websiteId] || websiteConfigs['default'];

  // Helper function to format description with actual values
  const formatDescription = (desc) => {
    return desc
      .replace('{contactName}', config.contactName)
      .replace('{phone}', config.phones[0])
      .replace('{phones}', config.phones.join(', '));
  };

  return {
    ...config,
    formattedDescription: formatDescription(config.description)
  };
};

/**
 * Get all available website IDs
 * @returns {string[]} Array of website IDs
 */
export const getAvailableWebsites = () => {
  return Object.keys(websiteConfigs).filter(key => key !== 'default');
};

/**
 * templae config for website
 * 
 * new_user_admin_alert
 * user_payment_process_started_admin_notification
 * user_payment_process_started_admin_notification
 * 
 */
export default websiteConfigs;
